import type { Control, FieldPath } from 'react-hook-form';
import { ControlledFormInput } from '@components/formInputs/ControlledFormInput';
import type { EventFormData } from '../RestaurantEventForm';
import styles from './TotalCapacityField.scss';

type TotalCapacityFieldProps = {
  control: Control<EventFormData>;
  name: FieldPath<EventFormData>;
};

export const TotalCapacityField = ({
  control,
  name,
}: TotalCapacityFieldProps) => (
  <div className={styles.totalCapacityRow}>
    <div className={styles.totalCapacityLabelWrap}>
      <div className={styles.totalCapacityLabelWrapInner}>
        <label htmlFor={name} className={styles.totalCapacityLabel}>
          Total Capacity
        </label>
        <ControlledFormInput<EventFormData>
          control={control}
          name={name}
          type="number"
          label=""
          className={styles.totalCapacityField}
          darkMode
          readOnly
        />
      </div>
      <span className={styles.totalCapacityUnit}>guests</span>
    </div>
  </div>
);
